import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const NotificationCenter = () => {
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);

  
useEffect(() => {
    const socket = io('https://www.weavevo.com', {
      path: '/socket.io/',          // Important pour le proxy Nginx
      transports: ['websocket'],    // Évite le fallback polling
      secure: true,
    });

    socket.on('connect', () => {
      console.log('🔌 Connecté au serveur de notifications');
    });

    socket.on('notification', (data) => {
      setNotifications((prev) => [data, ...prev]);
      setUnread((prev) => prev + 1);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const markAllAsRead = () => setUnread(0);

  return (
    <div className="dropdown">
      <button
        className="btn position-relative"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        onClick={markAllAsRead}
        title="Notifications"
        style={{
          background: 'transparent',
          border: 'none',
          padding: 0,
          color: '#000',
          fontSize: '1.5rem'
        }}
      >
        <i className="bi bi-bell"></i>
        {unread > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
            style={{
              backgroundColor: '#f02849', // rouge facebook
              color: 'white',
              fontSize: '0.65rem',
              fontWeight: 'bold',
              padding: '2px 5px',
              minWidth: '16px',
              height: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {unread}
          </span>
        )}
      </button>

      <ul
        className="dropdown-menu dropdown-menu-end p-2 shadow-sm"
        style={{
          minWidth: '320px',
          maxHeight: '400px',
          overflowY: 'auto',
          borderRadius: '8px',
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}
      >
        <li className="dropdown-header fw-bold text-dark">Notifications</li>
        <hr className="my-1" />
        {notifications.length === 0 ? (
          <li className="text-muted small px-2">Aucune notification</li>
        ) : (
          notifications.map((notif, idx) => (
            <li key={idx} className="mb-2 px-2 small">
              <div className="fw-bold text-dark">{notif.title}</div>
              <div className="text-muted">{notif.message}</div>
              <div className="text-end text-muted small">
                {new Date(notif.timestamp).toLocaleTimeString()}
              </div>
              <hr className="my-1" />
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default NotificationCenter;
